<script>
    import { createEventDispatcher } from 'svelte';
    import "./ShippingLaneFilterType";
    
    const dispatch = createEventDispatcher();

    export let filterHeader = "";
    export let filterOptions = [];
    export let filterType = ShippingLaneFilterType.FLAG;
    export let currentFilter = "";
    export let submitted = false;

    function onFilterChange(e) {
        dispatch('shippingLanesFilterChange', {
            filterType: filterType,
            selectedFilter: e.target.value,
        })
    }
</script>

<tr>
    <td width="40%">{filterHeader + ":"}</td>
    <td>
        {#if !submitted}
            <select on:change={(e)=>{onFilterChange(e)}}>
                {#each filterOptions as option}
                    <option value={option} selected={currentFilter === option}>{option}</option>
                {/each}
            </select>
        {:else}
            {currentFilter}
        {/if}
    </td>
</tr>